import Loadable from 'react-loadable';

import { Loading } from '../../common/navigation';


const StudentGoals = Loadable({
    loader: () => import('./components/student-goals'),
    loading: Loading,
  });


export const routes = [
    {
      path: '/student-goals',
      exact: true,
      name: 'student-goals',
      component: StudentGoals,
    },
  ];
  